import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import { slugify } from "../helpers";

class SquareSector extends React.Component {
  render() {
    const { square } = this.props;
    const slug = square.productName;    
    const sanitized = slugify(slug);            
    const url = `/products/${sanitized}/`;

    return (
      <dd
        className={`grid__item ${
          square.value < 1
            ? 'app--na'
            : square.value < 2
              ? 'app--limited'
              : square.value < 4
                ? 'app--qualified'
                : 'app--strong'
        }`}
      >
        <Link
          className="grid__link"
          to={{ pathname: url }}
          data-cta={`Appetite: ${square.biz}: ${slug}`}
        >
          <span className="grid__text">{square.productName}</span>
        </Link>
      </dd>
    );
  }
}

export default SquareSector;



// WEBPACK FOOTER //
// ./src/components/SquareSector.js